<main>
    <section class="well bg-color" style="padding-top: 0; padding-bottom: 0">
        <div class="container full-image-container">
            <iframe frameborder="0" allowfullscreen class="full-image-iframe"
                    src="https://momento360.com/e/u/5de5006818594d9b851ce1d5330c9538?utm_campaign=embed&utm_source=other&heading=-50.64015356177311&pitch=-8.899980411016685&field-of-view=75"></iframe>
        </div>
    </section>
    <section class="well bg-color center">
        <h3 style="margin-bottom: 40px;" class="center">{{"OTAYHTEYTTA" | translate}}</h3>
        <div class="container" style="display: flex; align-content: center; margin: auto; width: 70vw; flex-wrap: wrap">
            <div style="width: 100%; text-align: start">
                <h4>{{"CONTACT-INFO" | translate}}</h4>
                <hr/>
                <!-- <div>
                    <h6 style="color: black">{{"PASI-CONTACT-INFO-TITLE" | translate}}</h6>
                    <p>{{"PUHELIN" | translate}}. <a style="color: black" href="tel:+358407314828">+358 40 7314828</a></p>
                    <hr/>
                </div> -->
                <div>
                    <h6>{{"TONI-CONTACT-INFO-TITLE" | translate}}</h6>
                    <p>{{"PUHELIN" | translate}}. <a style="color: black" href="tel:+358447666977">+358 44 766 6977</a></p>
                    <hr/>
                </div>
                <div>
                    <h6 style="color: black">{{"ESA-CONTACT-INFO-TITLE" | translate}}</h6>
                    <p>{{"PUHELIN" | translate}}. <a style="color: black" href="tel:+358440124114">+358 44 012 4114</a></p>
                    <hr/>
                </div>
                <p>{{"EMAIL-FORMAT" | translate}}: <a style="color: black"
                                                      href="mailto:#">{{"SAHKOPOSTIMUOTO" | translate}}</a></p>
            </div>
            <div style="width: 100%; display: flex; flex-direction: row; justify-content: center; margin: 30px">
                <div style="height: 100%; display: flex; flex-direction: column; justify-content: center">
                    <img src="assets/images/HITEC-logo.png" style="max-height: 100px; object-fit: contain;">
                </div>
                <div style="height: 100%; display: flex; flex-direction: column; justify-content: center">
                    <img src="assets/images/evetco-logo.png" style="max-height: 100px; object-fit: contain;">
                </div>
            </div>
            <div style="width: 100%;">
                <div style="text-align: start">
                    <h4>Evetco Oy</h4>
                    <hr/>
                    <p><a target="_blank" href="https://goo.gl/maps/Yc8UeL4jRxWiGnWbA">Volttitie 18</a></p>
                    <p>26100 RAUMA</p>
                    <p>{{"PUHELIN" | translate}}. <a style="color: black" href="tel:0440124114">044 012 4114</a></p>
                    <hr/>
                    <p><a style="color: black" href="mailto:#">info@evetco.fi</a></p>
                    <p><a style="color: black" href="https://evetco.fi">www.evetco.fi</a></p>
                    <br/>
                    <p><a href="https://www.youtube.com/channel/UCc8cDmOx1o_yBk2HovTRYqA" target="_blank"><img
                            alt="youtube" style="height: 35px;" src="/assets/icons/youtube.svg"/></a></p>
                    <hr/>
                    <h6><a target="_blank" [href]="'BROCHURE-URL' | translate">{{"DOWNLOAD-BROCHURE" | translate}}</a>
                    </h6>

                </div>
            </div>
        </div>
    </section>
    <section class="map">
        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7700.310993761187!2d21.55269!3d61.1513486!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xda0f0fe9ad47d7dd!2sEvetco%20Ky!5e0!3m2!1sfi!2sfi!4v1598541196282!5m2!1sfi!2sfi"
                width="100%" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false"
                tabindex="0"></iframe>
    </section>
</main>
